(ns common.schema.entities.attestation
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.entities.common :as common]))

(def attestation-value-options
  [{:key   :attestation.value/no-objections
    :label "Approved"}
   {:key   :attestation.value/no-objections-subject-to-conditions
    :label "Conditionally approved"}
   {:key   :attestation.value/dissent
    :label "Not approved"}
   {:key   :attestation.value/not-applicable
    :label "N/A"}])

(def ^:private outcome-ui
  "Per-outcome UI/behaviour markers, kept next to the canonical enum so the
   frontend never hardcodes which value gets which badge variant or which value
   opens the conditions editor. `:requires-conditions?` drives the attestation
   modal's conditions section + the verifications card's 'review conditions'."
  {:attestation.value/no-objections                       {:variant :success}
   :attestation.value/no-objections-subject-to-conditions {:variant :warning :requires-conditions? true}
   :attestation.value/dissent                             {:variant :danger}
   :attestation.value/not-applicable                      {:variant :neutral}})

(def default-outcome-options
  "`attestation-value-options` in the {:value :label} input shape that the TP
   attestation UI and template outcome-option lists consume, enriched with the
   `outcome-ui` markers. Canonical outcome enum + labels live in exactly one
   place — this is the standard fallback when an attestation-type doesn't
   override via `:attestation-type/outcome-options`."
  (mapv (fn [{:keys [key label]}]
          (merge {:value key :label label} (get outcome-ui key)))
        attestation-value-options))

(def schema
  (vec
   (concat

    (su/date-field :attestation/date
                   "Attestation date"
                   {:authorization            su/access-user-user
                    :hidden-from-config?      true
                    :default-field-visibility :not-in-use})

    (su/text-multiline-field :attestation/comment
                             "Comment"
                             {:authorization            su/access-user-user
                              :hidden-from-config?      true
                              :default-field-visibility :not-in-use})

    (su/keyword-field :attestation/outcome
                      "Outcome"
                      attestation-value-options
                      {:authorization            su/access-user-user
                       :hidden-from-config?      true
                       :default-field-visibility :not-in-use})

    (su/boolean-field :attestation/draft?
                      "Draft"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})

    (su/boolean-field :attestation/completed?
                      "Completed"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})

    (su/multi-ref-field :attestation/conditions
                        "Conditions"
                        [:entity.type/attestation-condition]
                        {:authorization            su/access-user-user
                         :hidden-from-config?      true
                         :default-field-visibility :not-in-use})

    common/attachment-schema)))

(def required-fields
  #{:attestation/outcome})
